function getBranding() {
    return window.branding || {};
}

export { getBranding };
